import { Component, Input, OnInit } from '@angular/core';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { ITotalExtractionTable } from 'src/app/modules/widget/interfaces/total-extraction';

@Component({
  selector: 'app-total-extraction-table',
  templateUrl: './total-extraction-table.component.html',
  styleUrls: ['./total-extraction-table.component.scss'],
})
export class TotalExtractionTableComponent implements OnInit {
  public tableConfig: ITableConfig;
  @Input() public totalExtraction: ITotalExtractionTable[];
  constructor(private tableConfigService: TableConfigService) {}

  ngOnInit(): void {
    this.setTableConfig(this.totalExtraction);
  }
  /**
   * Function to set table configuration
   */
  private setTableConfig(totalExtraction: ITotalExtractionTable[]): void {
    const tableData = totalExtraction.map((item) => ({
      ...item,
      firstLoop: item.firstLoop?.toString() === 'Invalid date' ? '-' : item.firstLoop,
    }));
    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns: ['shiftPeriodId', 'totalLoops'],
      // largeColumns: ['operator']
    };

    const datasetParams: ITableDataParams = {
      tableData,
      dateConfig: [
        { field: 'firstLoop', format: 'date-time' },
        { field: 'lastLoop', format: 'date-time' },
      ],
      excludeColumns: ['shiftPeriodId', 'totalLoops'],
      // largeColumns: ['operator']
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    setTimeout(() => (this.tableConfig = { header, dataset }), 0);
  }
}
